import { Component, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { SettingsService } from './settings.service';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  faTriangleExclamation
} from '@fortawesome/free-solid-svg-icons';
import { CommonModule } from '@angular/common';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DialogsModule, WindowModule } from '@progress/kendo-angular-dialog';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

import { all } from '@awesome.me/kit-787edf9aa0/icons';
import { AutoFocusDirective } from '../directives/auto-focus.directive';
import { ApiService } from '../api/api.service';
import { Settings } from '../common/obj.lib';
import { LoggerService } from '../shared/logger.service';

@Component({
  selector: 'app-settings',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    InputsModule,
    ButtonsModule,
    DialogsModule,
    WindowModule,
    AutoFocusDirective
  ],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss'
})
export class SettingsComponent implements OnInit, OnDestroy {
  @ViewChild("appendTo", { read: ViewContainerRef }) appendTo: ViewContainerRef | undefined;

  form: FormGroup;

  settings: Settings = this.settingService.getSettings();
  private _subs: Subscription[] = [];

  constructor(
    private logger: LoggerService,
    private settingService: SettingsService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    public faIcons: FaIconLibrary,
    private apiService: ApiService
  ) {
    this.logger.debug(`SettingsComponent:constructor:settings: `, this.settingService.settings);
    faIcons.addIcons(faTriangleExclamation);
    faIcons.addIcons(...all);

    this.form = this.fb.group({
      apiUrl: [null, [Validators.required]],
      email: [null, [Validators.email]],
      pollingPeriod: [null, [Validators.required, Validators.min(1500)]],
      dbUser: [null, []],
      dbUserPw: [null, []],
      tunnelUserPw: [null, []],
      tunnelDbUsername: [null, []],
      tunnelDbPw: [null, []]
    })
  }

  //#region Form properties

  get f() {
    return this.form.controls;
  }
  get email() {
    return this.form.get('email');
  }
  get apiUrl() {
    return this.form.get('apiUrl');
  }
  get pollingPeriod() {
    return this.form.get('pollingPeriod');
  }
  get dbUser() {
    return this.form.get('dbUser');
  }
  get dbUserPw() {
    return this.form.get('dbUserPw');
  }
  get tunnelUserPw() {
    return this.form.get('tunnelUserPw');
  }
  get tunnelDbUsername() {
    return this.form.get('tunnelDbUsername');
  }
  get tunnelDbPw() {
    return this.form.get('tunnelDbPw');
  }

  //#endregion

  //#region Public methods

  ngOnInit(): void {
    this.logger.debug('ngOnInit...');
    this.initForm();
  }

  ngOnDestroy(): void {
    this.logger.debug('ngOnDestroy...');
    this._subs.forEach(s => s.unsubscribe());
  }

  onSubmit(): void {
    this.logger.debug('onSubmit...form.value', this.form.value);
    let toSubmit = new Settings(this.form.value);
    this.logger.debug('onSubmit:toSubmit', toSubmit);
    this.settingService.saveSettings(toSubmit);
    // this.apiService.setApiUrl(this.settingService.apiUrl);
    this.notify("Settings Updated");
    this.togglePristine();

  }

  cancelChanges() {
    this.form.reset();
    this.initForm();
    this.notify('Form has been reset');
  }

  //#region

  //#region Private methods

  private initForm() {
    this.settings = this.settingService.getSettings();
    this.logger.debug('initForm...', this.settings);
    this.form.patchValue({ ...this.settings });
  }

  private notify(msg: string, error: boolean = false): void {
    this.logger.debug("notify", msg);
    if (error) {
      this.toastr.error(msg);
    } else {
      this.toastr.success(msg);
    }
  }

  private toggleDirty() {
    this.form.markAsDirty();
  }
  private togglePristine() {
    this.form.markAsPristine();
  }

  //#endregion

}
